// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState } from "react";
import Header from "../../component/_elements/Header.tsx";
import { useOutletContext } from "react-router-dom";
import { OutletContextType, PonctualiteType } from "../../types/GlobalType.ts";
import { depenseContext } from "../../context/AppContext.js";

import ColumnChart from "../../component/boxes/chart/ChartColumn.tsx";
import CircularChartPaimentPerClass from "../../component/boxes/chart/CircularChartPaimentPerClass.tsx";
import { useQuery } from "@tanstack/react-query";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import { personalController } from "../../_api/controllers/personal.controller.ts";
import { paymentController } from "../../_api/controllers/payment.controller.ts";
import { depenseController } from "../../_api/controllers/depense.controller.ts";
import { studentAttendanceController } from "../../_api/controllers/attendance.controller.ts";
import moment from "moment";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import {
  classeController,
  motifPaiementController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { userController } from "../../_api/controllers/user.controller.ts";
const Dashboard: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };

  const { data: eleveData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });

  useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  useQuery({
    queryKey: ["users"],
    queryFn: userController.getAll,
  });

  const { data: personnelData } = useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });

  //fetch all payment data
  const {
    data: paiementData,
    isLoading: isLoadingPayment,
    isError: isErrorPayment,
  } = useQuery({
    queryKey: ["payments"],
    queryFn: paymentController.getAll,
  });

  // fetch motif Paiement
  useQuery({
    queryKey: ["motifPaiement"],
    queryFn: motifPaiementController.getAll,
  });

  //fetch depense
  const { data: depenseData } = useQuery({
    queryKey: ["depenses"],
    queryFn: depenseController.getAll,
  });

  //fetch attendance of the current month
  const date = moment().format("YYYY-MM-DD");

  const { data: studentAttendance } = useQuery({
    queryKey: ["studentAttendance"],
    queryFn: () => studentAttendanceController.getAllByMonth(date),
  });

  //sclarité request
  useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });
  useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });
  useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });
  useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  // fetch Active schoolYear
  const { data: activeSchoolYear } = useQuery({
    queryKey: ["ActiveSchoolYear"],
    queryFn: schoolYearController.getActive,
  });

  // console.log(eleveData);
  // console.log(personnelData);
  // console.log(paiementData);
  // console.log(depenseData);
  // console.log(studentAttendance);

  //calculate average of presence by month
  // const currentMonth = moment().format("YYYY-MM");
  const monthlyData = studentAttendance?.data ? studentAttendance : [];

  // const monthlyData = attendanceArray.filter((entry) =>
  //   entry.jour.startsWith(currentMonth)
  // );
  const total = monthlyData.length;
  const present = monthlyData.filter(
    (entry: PonctualiteType) =>
      entry.cote_eleve_id === 1 || entry.cote_eleve_id === 2
  ).length;

  const presenceRate = total > 0 ? ((present / total) * 100).toFixed(3) : 0;

  //Calculate scool fees for the current month
  const paymentArray = paiementData?.data ? paiementData.data : [];
  const monthlyPaymentData = paymentArray.filter((entry) =>
    entry.created_at.startsWith(moment().format("YYYY-MM"))
  );
  const totalMontant = monthlyPaymentData.reduce(
    (sum, item) => sum + item.montant,
    0
  );

  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />

      {/* Dashboard Content */}
      <main className="p-6 mt-16">
        <div className="mb-8">
          <h1 className="text-2xl font-bold mb-1">Tableau de bord</h1>
          <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Bienvenue sur votre tableau de bord de gestion scolaire.
          </p>
        </div>
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {/* Total Élèves */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"}`}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Total Élèves</h2>
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  isDarkMode ? "bg-blue-900" : "bg-blue-100"
                }`}
              >
                <i className="fas fa-user-graduate text-blue-500"></i>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-3xl font-bold">{eleveData?.size || 0}</span>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Élèves inscrits pour l'année scolaire
            </p>
            {/* <p className="text-sm text-green-500 mt-2">
              <i className="fas fa-arrow-up mr-1"></i> 1.2% depuis le mois
              dernier
            </p> */}
          </div>
          {/* Enseignants */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"}`}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Personnels</h2>
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  isDarkMode ? "bg-indigo-900" : "bg-indigo-100"
                }`}
              >
                <i className="fas fa-chalkboard-teacher text-indigo-500"></i>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-3xl font-bold">
                {personnelData?.size || 0}
              </span>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Enseignants actifs
            </p>
            {/* <p className="text-sm text-green-500 mt-2">
              <i className="fas fa-arrow-up mr-1"></i> 1.4% depuis le mois
              dernier
            </p> */}
          </div>
          {/* Taux de présence */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"}`}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Taux de présence</h2>
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  isDarkMode ? "bg-teal-900" : "bg-teal-100"
                }`}
              >
                <i className="fas fa-clipboard-check text-teal-500"></i>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-3xl font-bold">{presenceRate} %</span>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Moyenne mensuelle
            </p>
            {/* <p className="text-sm text-green-500 mt-2">
              <i className="fas fa-arrow-up mr-1"></i> 3% depuis le mois dernier
            </p> */}
          </div>
          {/* Paiements */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"}`}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold">Paiements</h2>
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  isDarkMode ? "bg-purple-900" : "bg-purple-100"
                }`}
              >
                <i className="fas fa-credit-card text-purple-500"></i>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-3xl font-bold">{totalMontant} $</span>
            </div>
            <p
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              Frais perçus ce mois
            </p>
            {/* <p className="text-sm text-red-500 mt-2">
              <i className="fas fa-arrow-down mr-1"></i> 2% depuis le mois
              dernier
            </p> */}
          </div>
        </div>
        {/* Activity and Events */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Recent Activities */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"} lg:col-span-2`}
          >
            <h2 className="text-xl font-bold mb-6">
              Statistiques annuelles des paiements
            </h2>
            <div className="space-y-6">
              {/* <paiementContext.Provider value={paiementData}> */}
              <depenseContext.Provider value={depenseData}>
                <ColumnChart isLoading={isLoadingPayment} />
              </depenseContext.Provider>
              {/* </paiementContext.Provider> */}
            </div>
          </div>
          {/* Upcoming Events */}
          <div
            className={`rounded-lg p-6 ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } ${!isDarkMode && "shadow-md"}`}
          >
            <h2 className="text-xl font-bold mb-6">Statistiques - Elèves </h2>
            <div
              className={`rounded-lg p-4 mb-4 ${
                isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
              }`}
            >
              <h3 className="font-semibold mb-2">Par genre</h3>

              <CircularChartPaimentPerClass />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
